// extracted by mini-css-extract-plugin
var _1 = "TemplateCardContainer_root__528fa";
export { _1 as "root" }
